// File Management Utilities for Super Wear

export const generateImagePath = (category, fileName, isMainImage = false) => {
  const timestamp = Date.now();
  const fileExtension = fileName.split('.').pop();
  const sanitizedFileName = fileName.replace(/[^a-zA-Z0-9.-]/g, '_').toLowerCase();
  
  const prefix = isMainImage ? 'main-' : '';
  const finalFileName = `${prefix}${timestamp}-${sanitizedFileName}`;
  
  return `/src/assets/products/${category}/${finalFileName}`;
};

export const generateUserAvatarPath = (userId, fileName, userType = 'customers') => {
  const timestamp = Date.now();
  const fileExtension = fileName.split('.').pop();
  const finalFileName = `user-${userId}-${timestamp}.${fileExtension}`;
  
  return `/src/assets/users/avatars/${userType}/${finalFileName}`;
};

export const generateWebsiteAssetPath = (assetType, fileName, subFolder = '') => {
  const timestamp = Date.now();
  const sanitizedFileName = fileName.replace(/[^a-zA-Z0-9.-]/g, '_').toLowerCase();
  const finalFileName = `${timestamp}-${sanitizedFileName}`;
  
  const basePath = `/src/assets/website/${assetType}`;
  return subFolder ? `${basePath}/${subFolder}/${finalFileName}` : `${basePath}/${finalFileName}`;
};

export const validateImageFile = (file, maxSizeMB = 5) => {
  const errors = [];
  
  // Check file type
  if (!file.type.startsWith('image/')) {
    errors.push('Please select an image file (JPG, PNG, WebP)');
  }
  
  // Check file size
  const maxSizeBytes = maxSizeMB * 1024 * 1024;
  if (file.size > maxSizeBytes) {
    errors.push(`Image size should be less than ${maxSizeMB}MB`);
  }
  
  // Check file extension
  const allowedExtensions = ['jpg', 'jpeg', 'png', 'webp'];
  const fileExtension = file.name.split('.').pop().toLowerCase();
  if (!allowedExtensions.includes(fileExtension)) {
    errors.push('Only JPG, PNG, and WebP formats are supported');
  }
  
  return {
    isValid: errors.length === 0,
    errors: errors
  };
};

export const createImagePreview = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(e.target.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export const getAssetFolderStructure = () => {
  return {
    products: {
      'ready-to-wear': ['embroidered', 'printed', 'formal', 'casual', 'summer', 'winter'],
      'unstitched': ['lawn', 'cotton', 'silk', 'chiffon', 'jacquard'],
      'men': ['kurta', 'shalwar-kameez', 'waistcoat', 'formal', 'casual'],
      'western': ['dresses', 'tops', 'trousers', 'jackets', 'skirts'],
      'accessories': ['bags', 'jewelry', 'shoes', 'scarves', 'watches'],
      'fragrances': ['men', 'women', 'unisex'],
      'kids': ['boys', 'girls', 'toddlers', 'babies']
    },
    users: {
      'avatars': ['admin', 'customers', 'staff'],
      'profiles': ['cover-photos', 'gallery', 'documents']
    },
    website: {
      'banners': ['home-slider', 'category-banners', 'promotional', 'seasonal'],
      'logos': ['main-logo', 'favicon', 'social-media', 'print-media'],
      'icons': ['navigation', 'features', 'social', 'payment']
    }
  };
};

export const getRecommendedImageSizes = () => {
  return {
    products: {
      main: { width: 800, height: 1200, description: 'Main product image' },
      thumbnail: { width: 300, height: 450, description: 'Thumbnail for listings' },
      gallery: { width: 600, height: 900, description: 'Gallery images' }
    },
    users: {
      avatar: { width: 300, height: 300, description: 'User profile picture' },
      cover: { width: 1200, height: 400, description: 'Profile cover photo' }
    },
    website: {
      banner: { width: 1920, height: 600, description: 'Home page banner' },
      categoryBanner: { width: 1200, height: 400, description: 'Category page banner' },
      logo: { width: 200, height: 80, description: 'Website logo' },
      favicon: { width: 32, height: 32, description: 'Browser favicon' }
    }
  };
}; 